import {orderScenarioFeedbackJson} from "@/helpers/feedbackJsonHelpers";
import {useScoreValue} from "@/hooks/ScoreValue";

import {useMemo} from "react";

import {BackButton} from "@ui/buttons/BackButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const FeedbackResult = ({onClickBack}) => {
  const {feedback, feedback_json} = useSelector(
    (state) => state.ml.summarization,
  );
  const {sessions} = useSelector((state) => state.common.viewTabs);

  const {processFeedback, getScoreEnding} = useScoreValue();
  const orderedFeedbackJson = useMemo(
    () => orderScenarioFeedbackJson(feedback_json),
    [feedback_json],
  );

  return (
    <div className={styles.feedbackResult}>
      <BackButton onClick={() => onClickBack()} />

      {feedback_json ? (
        <RootDesc>
          <div
            className={styles.feedbackJson}
            style={
              sessions === "certification" || sessions === "scenario"
                ? {
                    display: "grid",
                    gridTemplateColumns: "repeat(3,1fr)",
                    gap: "24rem 16rem",
                  }
                : {}
            }
          >
            {orderedFeedbackJson.map((item) => (
              <div key={item.header}>
                <article>
                  {item.header && <strong>{item.header}</strong>}

                  {item.score && (
                    <b>
                      {item.score}
                      {getScoreEnding(item.score || 0)}
                    </b>
                  )}
                </article>

                {item.feedback && <span>{item.feedback}</span>}
              </div>
            ))}
          </div>
        </RootDesc>
      ) : (
        <RootDesc>
          <span
            dangerouslySetInnerHTML={{
              __html:
                sessions === "certification" || sessions === "scenario"
                  ? processFeedback(feedback || "")
                  : feedback || "",
            }}
          />
        </RootDesc>
      )}
    </div>
  );
};
